export default __webpack_public_path__ + "static/profilepic-f75e4d14f452ea72280f2763c4b18443.svg";